<template>
  <Transition name="customer-group-modal-overlay">
    <div
      v-if="visible"
      class="customer-group-modal-overlay customer-group-modal-overlay--glass"
      @click.self="$emit('cancel')"
    >
      <Transition name="customer-group-modal-panel" appear>
        <div
          v-if="visible"
          class="customer-group-modal-card customer-group-modal-card--glass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="note-priority-modal-title"
          @click.stop
        >
          <div class="customer-group-modal-header customer-group-modal-header--glass">
            <h2 id="note-priority-modal-title" class="customer-group-modal-title">{{ modalTitle }}</h2>
            <button type="button" class="customer-group-modal-close-btn" aria-label="Close" @click="$emit('cancel')">
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>
          <div class="customer-group-modal-body customer-group-modal-body--glass">
            <LabelInputField
              input-id="note-priority-name"
              label="Name"
              v-model="itemName"
              placeholder="e.g. High"
              required
              flex
              :has-error="!!error"
              :disabled="saving"
              @input="error = ''"
            >
              <div v-if="error" class="customer-group-modal-error">{{ error }}</div>
            </LabelInputField>
          </div>
          <div class="customer-group-modal-actions customer-group-modal-actions--glass">
            <SecondaryButton label="Cancel" :disabled="saving" @click="$emit('cancel')" />
            <PrimaryButton label="Save" :loading="saving" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
  <ErrorModal :show="showErrorModal" title="Error" :message="errorMessage" buttonText="OK" @close="closeErrorModal" />
</template>

<script>
import '../styles/AddNewCustomerGroup.css';
import noteMetaService from '@/services/noteMeta.service.js';
import ErrorModal from '@/components/ErrorModal.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'AddNewNotePriority',
  components: { ErrorModal, LabelInputField, PrimaryButton, SecondaryButton },
  props: {
    visible: { type: Boolean, default: false },
    companyId: { type: [String, Number], required: true },
    editingItem: { type: Object, default: null },
  },
  emits: ['cancel', 'ok'],
  data() {
    return {
      itemName: '',
      error: '',
      saving: false,
      showErrorModal: false,
      errorMessage: '',
    };
  },
  computed: {
    isEditMode() {
      return !!this.editingItem?.id;
    },
    modalTitle() {
      return this.isEditMode ? 'Edit Note Priority' : 'Note Priority';
    },
  },
  watch: {
    visible(open) {
      if (open) this.resetForm();
    },
    editingItem() {
      if (this.visible) this.resetForm();
    },
  },
  methods: {
    resetForm() {
      this.itemName = this.isEditMode ? (this.editingItem.name || '') : '';
      this.error = '';
    },
    async ok() {
      if (!this.itemName.trim()) {
        this.error = 'Name is required.';
        return;
      }
      this.saving = true;
      try {
        const payload = {
          name: this.itemName.trim(),
          companyId: this.companyId,
        };
        const response = this.isEditMode
          ? await noteMetaService.updateNotePriority(this.editingItem.id, payload)
          : await noteMetaService.createNotePriority(payload);
        this.$emit('ok', response?.data?.data || response?.data);
        if (!this.isEditMode) this.itemName = '';
      } catch (err) {
        this.errorMessage = err.response?.data?.error || err.response?.data?.message || err.message || `Failed to ${this.isEditMode ? 'update' : 'create'} note priority.`;
        this.showErrorModal = true;
      } finally {
        this.saving = false;
      }
    },
    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
  },
};
</script>
